module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcforearm0-2823fa1141a3882a2d456bbb76f11289.jpg";